export default __webpack_public_path__ + "static/media/icon-disabilities.a1ec07d7.svg";